<template>
    <div>
        <!-- <p v-for="item in messageServiceList" :key="item.messageservicecode">
            {{item.messageservicename}}
        </p>

        <p v-for="item in passwayTypeList" :key="item.passwaytype">
            {{item.passwaytypename}}
        </p> -->
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="id" >
            <!-- <template slot="operation" slot-scope="text, record">
                <router-link class="tableLink" :to="{path:'detail_channel',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink"  :to="{path:'edit_channel',query: {id: record.id,}}">渠道设置</router-link>
            </template> -->

            <template slot="status" slot-scope="text">
               <span v-if="text == '02'">
                   开启
               </span>
               <span v-else-if="text == '01'">
                   未开启
               </span>
               <span v-else>
                   --
               </span>
            </template>

             <template slot="messageService" slot-scope="text">
               <span>
                   {{ getMessageServiceName(text) }}
               </span>
            </template>

            <template slot="passwaytypeID" slot-scope="text">
               <span>
                   {{ getPasswayTypeName(text) }}
               </span>
            </template>

            <template slot="opration" slot-scope="record">
                    <a-icon style="color:#1890ff;" size="large" type="file-search" @click="handleDetail(record)" />
                </template>
            <template slot="viewhistory" slot-scope="record">
                    <a-icon style="color:#1890ff;" size="large" type="history" @click="handleHistory(record)" />
                </template>
            <template slot="resendmsg" slot-scope="record">
                <a-popconfirm title="确认重新发送?" @confirm="() => handleResend(record)">
                    <a class="tableLink"  href="javascript:;">重新发送</a>
                </a-popconfirm>
            </template>
                
        </a-table>



        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

        <a-modal v-model="modalVisible" title="报文" @ok="handleOk">
                 <json-viewer
                    :value="modalData"
                    :expand-depth=5
                    copyable
                    boxed
                    sort></json-viewer>
            </a-modal>
    </div>
</template>
<script>
let pagination ={
    page:1,
    pageSize:10,
    total:0
};

const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        },
        fixed: 'left'

    },
    {
        title: "消息ID",
        dataIndex: "messageid",
        align: 'center',
        ellipsis:true,
        fixed: 'left',
        width:180
    },
    {
        title: "详情",
        width:50,
        scopedSlots: { customRender: 'opration' },
        align: "center",
        ellipsis: true,
        fixed: 'left'
    },
    {
        title: "查看消息明细",
        width:120,
        scopedSlots: { customRender: 'viewhistory' },
        align: "center",
        ellipsis: true,
        fixed: 'left'
    },
    {
        title: "操作",
        width:100,
        scopedSlots: { customRender: 'resendmsg' },
        align: "center",
        ellipsis: true,
        fixed: 'left'
    },
    {
        title: "标题",
        dataIndex: "messagetitle",
        align: 'center',
        ellipsis:true,
        width:200
    },
    {
        title: "内容",
        dataIndex: "messageecontent",
        align: 'center',
        ellipsis:true,
        width:180
    },
    {
        title: "发送方式",
        dataIndex: "messagesendtypename",
        align: 'center',
        width:80
    },
    {
        title: "通道类型",
        dataIndex: "passwaytype",
        scopedSlots: { customRender: 'passwaytypeID' },
        align: 'center',
        ellipsis: true,
        width:120
    },
    {
        title: "业务类型",
        dataIndex: "messageservicecode",
        scopedSlots: { customRender: 'messageService' },
        align: 'center',
        ellipsis: true,
        width:120
    },
    {
        title: "发送时间",
        dataIndex: "messagesendtime",
        width:180,
        align: 'center',
    },
    {
        title: "有效开始时间",
        dataIndex: "showtimestart",
        width:180,
        align: 'center',
    },
    {
        title: "有效结束时间",
        dataIndex: "showtimeend",
        width:180,
        align: 'center',
    },
    {
        title: "推送目标",
        dataIndex: "receivertypename",
        align: 'center',
        ellipsis: true,
        width:100
    },
    {
        title: "目标人群",
        dataIndex: "receivervalue",
        align: 'center',
        ellipsis:true,
        width:200
    },
    {
        title: "处理状态",
        dataIndex: "statusname",
        align: 'center',
        width:80
    }
    // {
    //     title: "渠道名称",
    //     dataIndex: "channelname",
    //     align: 'center',
    //     ellipsis:true,
    //     width:180
    // },




    // {
    //     title: "内容",
    //     dataIndex: "messageecontent",
    //     width:120
    // },
    // {
    //     title: "额外参数",
    //     dataIndex: "messageextras",
    //     width:120
    // },



    // {
    //     title: "平台类型",
    //     dataIndex: "platformtype",
    //     align: 'center',
    //     width:80
    // },
    // {
    //     title: "平台编码",
    //     dataIndex: "platformcode",
    //     align: 'center',
    //     width:80
    // },



    // {
    //     title: '操作',
    //     dataIndex: 'operation',
    //     align: 'center',
    //     width: 150,
    //     scopedSlots: { customRender: 'operation' },
    //     fixed: 'right',
    // }

];

import {mapState} from "vuex";
import JsonViewer from "vue-json-viewer"


export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            modalData:{},
            modalVisible:false,
            searchP:{
                keyword:'',
                channelcode:'',
                starttime:'',
                endtime:'',
                channels:[]
            }
        };
    },
    methods: {
        handleHistory(record){
            //站内信/websocket
            if(record.passwaytype == 'PASSTYPE-003'){
                this.$router.push({
                    path: "wshistory",
                    query:{
                        messageid:record.messageid,
                    }
                });
            }
            else{
                this.$router.push({
                    path: "messagehistory",
                    query:{
                        messageid:record.messageid,
                    }
                });
            }
            
        },
        handleResend(record){
            let that = this
            let params = {
                messageid:record.messageid,
                urlparams:false
            };
            that.tloading = true;

            that.$store.dispatch({
                type: "mcmsmanager/resendMcmsMessageRecord",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    that.getAppSumData()
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleOk(){
            this.modalVisible = false;
        },
        handleDetail(record){
            this.modalData = record;
            this.modalVisible = true;
        },
        getMessageServiceName(text){
            let targetItem = this.messageServiceList.filter( item => { return item.messageservicecode == text } );
            if(targetItem.length > 0){
                return targetItem[0].messageservicename
            }
            else{
                return text;
            }
        },
        getPasswayTypeName(text){
            let targetItem = this.passwayTypeList.filter( item => { return item.passwaytype == text } );
            if(targetItem.length > 0){
                return targetItem[0].passwaytypename
            }
            else{
                return text;
            }
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },

        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.tloading = true;
            that.$store.dispatch({
                type: "mcmsmanager/querymessagepage",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.tableData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        }
    },
    computed: {
        ...mapState('mcmsmanager', {
            messageServiceList: state => state.messageServiceList,
            passwayTypeList:state => state.passwayTypeList,

        })
    },
    components:{
        JsonViewer
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

